export const FetchStatus = {
  UNSENT: 'UNSENT',
  LOADING: 'LOADING',
  DONE: 'DONE',
  ERROR: 'ERROR',
}

export const TaskSource = {
  ASSESSMENT: 'ASSESSMENT',
  GOAL: 'GOAL',
  GOAL_TASK: 'GOAL_TASK',
  LEARNING_ITEM: 'LEARNING_ITEM',
  ONE_ON_ONE: 'ONE_ON_ONE',
  TO_DO: 'TO_DO',
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/constants.js